import { useAuthenticatedContext } from '../hooks/useAuthenticatedContext';
import { User } from './user';

export function useUser(): User | null | undefined {
    const authContext = useAuthenticatedContext();
    return authContext.user;
}
